import { render } from "./IconScan1D.vue?vue&type=template&id=065c331a"
import script from "./IconScan1D.vue?vue&type=script&lang=ts"
export * from "./IconScan1D.vue?vue&type=script&lang=ts"
script.render = render

export default script